<template>
  <div class="unit-items">
    <div class="unit-title">
      <span class="small black--text font-weight-bold text-uppercase">{{
        subtitle
      }}</span>
      <h3 class="font-weight-regular mb-0 black--text title">
        {{ title }}
      </h3>
    </div>

    <div
      v-for="(item, index) in orderedList"
      :key="`unit-${index}`"
      class="item"
      :data-id="`${Math.round(new Date().getTime() / 1000)}`"
    >
      <div v-if="item.el" v-html="item.el"></div>

      <v-chip color="amber">{{ item.count }}</v-chip>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import lodash from "lodash";
export default {
  name: "AreaItems",
  data() {
    return {
      items: this.value,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    subtitle: String,
  },
  computed: {
    orderedList() {
      return lodash.orderBy(this.items, "count", "desc");
    },
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  min-height: 30vh;
  .item {
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0.5rem 0;
    border-radius: 5px;
    color: black;
    background: rgb(255, 255, 255, 0.9);
    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  padding-bottom: 0px;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
</style>
